import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=28f46a04"
import script from "./BusinessInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&lang=js"
import style0 from "./BusinessInfo.vue?vue&type=style&index=0&id=28f46a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports